// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.Ping in ping/ping.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import okio.ByteString

/**
 * Ping message, used to test communication between client and target device.
 *
 * @property id Unique identifier for the ping message
 */
public class Ping(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val id: Int = 0,
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<Ping, Nothing>(ADAPTER, unknownFields) {
  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is Ping) return false
    if (unknownFields != other.unknownFields) return false
    if (id != other.id) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + id.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """id=$id"""
    return result.joinToString(prefix = "Ping{", separator = ", ", postfix = "}")
  }

  public fun copy(id: Int = this.id, unknownFields: ByteString = this.unknownFields): Ping = Ping(id, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<Ping> = object : ProtoAdapter<Ping>(
      FieldEncoding.LENGTH_DELIMITED, 
      Ping::class, 
      "type.googleapis.com/vreo.volt.protocol.Ping", 
      PROTO_3, 
      null, 
      "ping/ping.proto"
    ) {
      override fun encodedSize(`value`: Ping): Int {
        var size = value.unknownFields.size
        if (value.id != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(1, value.id)
        }
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: Ping) {
        if (value.id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.id)
        }
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: Ping) {
        writer.writeBytes(value.unknownFields)
        if (value.id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 1, value.id)
        }
      }

      override fun decode(reader: ProtoReader): Ping {
        var id: Int = 0
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> id = ProtoAdapter.INT32.decode(reader)
            else -> reader.readUnknownField(tag)
          }
        }
        return Ping(
          id = id,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: Ping): Ping = value.copy(
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
